enum NotificationConnectionVariantEnum {
  /**Нет подключения*/
  Disconnected = "disconnected",
  /**Подключение успешно*/
  Connected = "connected",
  /**Переподключение */
  Reconnected = "reconnected",
}

export default NotificationConnectionVariantEnum;
